module.exports = __webpack_public_path__ + "img/smile.037322de.svg";